import { BarcodeFormat, BrowserCodeReader, BrowserMultiFormatReader } from "@zxing/browser";
import { BinaryBitmap, DecodeHintType, HybridBinarizer, RGBLuminanceSource } from "@zxing/library";
import jsQR from "jsqr";
import { useEffect, useRef } from "react";

// Simple element to do scanning with video stream
export function BarcodeScanner(props) {
	let {
		onScan,  // Triggers on a scan, receiving a text string.  Should return true to stop the scanning process, false to continue.
		...passableProps
	} = props;

	// Refs
	let videoRef = useRef();
	let canvasRef = useRef();

	// When mounted, start reading streams
	useEffect(() => {
		if(navigator.mediaDevices == null) {
			// Don't crash if media devices are absent
			console.log("Media devices not available");
			return;
		}
		navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } }).then(function(stream) {
			// The video stream should be from the rear-facing camera
			let video = videoRef.current;
			video.srcObject = stream;
			video.play();

			// Create the Reader
			let zxing = new BrowserMultiFormatReader();
			// const hints = new Map(); // Use hints or get rid of them? (currently not connected to reader)
			// Formats - https://github.com/zxing-js/library
			// const formats = [BarcodeFormat.QR_CODE, BarcodeFormat.EAN_13, BarcodeFormat.EAN_8, BarcodeFormat.UPC_A, BarcodeFormat.UPC_E, BarcodeFormat.UPC_EAN_EXTENSION, BarcodeFormat.DATA_MATRIX ];
			// hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);
			// hints.set(DecodeHintType.TRY_HARDER, true);
			// zxing.setHints(hints);

			// Continually run the scan
			let scanMe = async () => {
				if (video.readyState === video.HAVE_ENOUGH_DATA) {
					let canvasElement = canvasRef.current;
					if(canvasElement == null) { // Removed from DOM
						return; // Quit and don't scan again
					}

					// Draw video image onto invisible canvas
					let canvas = canvasElement.getContext("2d");
					canvasElement.width = video.videoWidth;
					canvasElement.height = video.videoHeight;
					canvas.drawImage(video, 0, 0, canvasElement.width, canvasElement.height);
					// Retrieve data from canvas
        			var imageData = canvas.getImageData(0, 0, canvasElement.width, canvasElement.height);

					// This is where the decoded text will be stored
					let qrText = null;

					// Check jsQR
        			var qrData = jsQR(imageData.data, imageData.width, imageData.height, {
          				inversionAttempts: "attemptBoth",
        			});
					if(qrData != null) {
						console.log("Found jsQR");
						console.log(qrData);
						qrText = qrData.data;
					}
					
					if(!qrText) {
						// Check ZXing
						try {
							let result = zxing.decodeFromCanvas(canvasElement);
							console.log("Found ZXing");
							console.log(result);
							qrText = result.text;
						} catch(err) {  
							// It errors out anytime it doesn't find something
						}
					}

					// Be sure there is actually data because a null check isn't enough - had it occasionally scanning emptiness as a valid empty string
					if(!!qrText) {
						// Run the trigger and see if we should stop or keep going
						let shouldStopScanning = onScan(qrText);
						if(shouldStopScanning) {
							return; // Don't run requestAnimationFrame again
						}	
					}
				}
				// Call on next repaint
				requestAnimationFrame(scanMe);
			};
			// Start the stream
			requestAnimationFrame(scanMe);
		});
	});

	return <div {...passableProps}>
		<canvas ref={canvasRef} style={{display:"none"}}></canvas>
		<video ref={videoRef} playsInline style={{width: "100%"}} />
	</div>;
}